























































import { Component, Vue, Prop } from 'vue-property-decorator';

enum ActionType {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
}

@Component
export default class LinkedAccountCard extends Vue {
  @Prop(String) readonly icon!: string;
  @Prop(String) readonly iconName!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly actionType!: ActionType;
  @Prop(Boolean) readonly actionPending!: boolean;

  ActionType = ActionType;

  get buttonText() {
    return this.actionType === ActionType.CONNECT
      ? this.$t(
          'components.settings.LinkedAccounts.socialLogins.connectSocial',
          { name: this.name },
        )
      : this.$t('components.discord.discordDialog.disconnect');
  }

  handleClick() {
    if (this.actionType === ActionType.CONNECT) {
      this.$emit('connect-clicked');
    } else {
      this.$emit('disconnect-clicked');
    }
  }
}
